import { useState, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import ReactImageMagnify from 'react-image-magnify';

import PaymentInfo from './PaymentInfo';
import PromotionConditions from './PromotionConditions';

import { basicMsg } from '../../../actions/swal_msg';
import { getTitle } from '../../../helpers/admin/productHelper';
import { saveItemToCart, shopProductViewed } from '../../../actions/shop';
import { formatMainImage, getCategoryURL } from '../../../helpers/shop/shopHelper';

//gallery
import ImageGallery from 'react-image-gallery';
import '../../../../node_modules/react-image-gallery/styles/css/image-gallery.css';
import shape from '../../../assets/resources/shape.png';

import {
    Typography, Grid, Stack, Container, Box, TextField, Button,
    AccordionSummary, AccordionDetails, FormControl, Rating, useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { regex_num } from '../../../constants/regex';
import { GOOGLE_DRIVE_CDN, PRODUCT_NO_IMG, SUPPORT_NUMBER } from '../../../constants/constants';
import { FREE_SHIPPING_THRESHOLD } from '../../../constants/shop/shop_constants';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    borderTop: `1px solid #CACFD2`,
    borderBottom: `1px solid #CACFD2`,
    '&:not(:last-child)': {
        borderBottom: 0
    },
    '&:before': {
        display: 'none'
    }
}));

const WhatsAppButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    height: 40,
    color: '#fff',
    backgroundColor: '#25d366',
    '&:hover': {
        backgroundColor: '#52BE80',
        color: '#fff'
    }
}));

const ProductContainer = forwardRef(({
    _product, account_id,
    product, variant, setVariant,
    qty, setQty,
    fullTitle, setFullTitle,
    currentImages, setCurrentImages
}, ref) => {
    // producto
    const {
        _id: prod_id, title, url, brand, category, prod_category,
        refrigerated, medicine, prod_variants,
        review_summary = { average: 0, count: 0 }
    } = product;
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [expanded, setExpanded] = useState('panel1');
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // variantes
    const {
        _id: prod_var_id, variant_title, price, stock, description,
        item_promotion: { promo, price: promo_price, text, fontSize, description: promotionDescription },
        freeShipping
    } = variant;
    
    const matches = useMediaQuery('(max-width: 950px)');
    const matches_1 = useMediaQuery('(max-width: 410px)');
        
    // cantidad de producto a agregar
    const handleChangeQty = ({ target }) => {
        const value = target.value;
        const _num = Number(target.value);
        if (value.trim() === '' ||
            (regex_num.test(value) && _num > 0))
            setQty(value);
    };

    // agregar al carrito
    const handleSubmit = (event) => {
        event.preventDefault();
        const _qty = Number(qty);
        if (_qty > 0) {
            if (stock <= 0)
                basicMsg('No hay stock disponible');
            else {
                const model = {
                    prod_id, prod_var_id, quantity: _qty
                };
                dispatch(saveItemToCart(model, { flag: true, message: [] }, () => {}));
                // Tag Manager
                window.dataLayer.push({
                    event: 'add-to-cart'
                });
            }
        }
    };

    // comprar ahora
    const handleBuyNow = (event) => {
        event.preventDefault();
        const _qty = Number(qty);
        if (_qty > 0) {
            if (stock <= 0)
                basicMsg('No hay stock disponible');
            else {
                const model = {
                    prod_id, prod_var_id, quantity: _qty
                };
                dispatch(saveItemToCart(model, { flag: false, message: [] }, () => {}));
                // Tag Manager
                window.dataLayer.push({
                    event: 'add-to-cart'
                });
                setTimeout(() => {
                    navigate('/carrito');
                }, 500);
            }
        }
    };

    // variante seleccionada
    const variantSelect = VariantModel => () => {
        const {
            _id: prod_var_id, variant_title, price_no_iva,
            price, iva, barcode, images, item_promotion
        } = VariantModel;

        navigate(`/tienda/producto/${_product}/${barcode}`, { replace: true });

        setVariant({ ...VariantModel, checked: true });

        setFullTitle(getTitle(title, variant_title));

        // nueva variante vista
        dispatch(shopProductViewed(account_id, {
            prod_id, prod_var_id, title, variant_title, url,
            brand, review_summary, price_no_iva, price, iva, barcode,
            img: formatMainImage(images), item_promotion
        }));

        if (images.length > 0)
            setCurrentImages(images.map(e =>
                ({
                    original: `${GOOGLE_DRIVE_CDN}${e.id}`,
                    thumbnail: `${GOOGLE_DRIVE_CDN}${e.id}`
                })
            ));
        else
            setCurrentImages([{
                original: `${GOOGLE_DRIVE_CDN}${PRODUCT_NO_IMG}`,
                thumbnail: `${GOOGLE_DRIVE_CDN}${PRODUCT_NO_IMG}`
            }]);
    };
    
    return (
        <Container maxWidth='xxl' sx={{ mt: 6 }}>
            <Grid container spacing={5}>
                <Grid item xl={4.5} lg={6} md={6} sm={12} xs={12}>
                    <div className='product_gallery'>
                        <div className='img_product'>
                            {
                                matches ? <div id='portal'></div> : null
                            }
                            <ImageGallery items={currentImages} showPlayButton={false} useBrowserFullscreen={false}
                                showFullscreenButton={false} thumbnailPosition={matches ? 'bottom' : 'left'} showNav={false}
                                renderItem={
                                    (item) =>
                                        <ReactImageMagnify
                                            {...{
                                                smallImage: {
                                                    alt: 'nfps_prod',
                                                    isFluidWidth: true,
                                                    src: item.original,
                                                },
                                                largeImage: {
                                                    src: item.original,
                                                    width: 1200,
                                                    height: 1200,
                                                },
                                                enlargedImagePortalId: 'portal',
                                                enlargedImageContainerDimensions: {
                                                    width: matches ? '105%' : '130%',
                                                    height: matches ? '100%' : '130%'
                                                }
                                            }}
                                        />
                                }
                            />
                        </div>

                        {
                            promo !== '' &&
                                <div className="product_top-image" title={promotionDescription}>
                                    <img src={shape} alt={shape} width='90' style={{ pointerEvents: 'none' }} />
                                    <div className="product_centered_image">
                                        <Typography sx={{ color: '#fff', fontSize, fontWeight: 'bold' }}>
                                            { text }
                                        </Typography>
                                    </div>
                                </div>
                        }
                        <Typography
                            sx={{ mt: 1.5, fontWeight: '500' }}
                            variant='body1'
                            textAlign='center'>
                            {matches ? 'Mantén tu dedo sobre la imagen para hacer zoom' : 'Pasa el mouse encima de la imagen para aplicar zoom'}
                        </Typography>
                    </div>
                </Grid>
                <Grid item xl={4.5} lg={6} md={6} sm={12} xs={12}>
                    {
                        matches ? null : <div id='portal'></div>
                    }

                    {/* Nombre del producto */}
                    <Typography variant="h5" sx={{ fontWeight: '500', mt: { xs: 1, sm: 1, md: 0 } }}>
                        { fullTitle }
                    </Typography>
                    {/* Fin Nombre del producto */}

                    {/* Rating del producto */}
                    <Box sx={{ mt: .5 }}>
                        {
                            review_summary.count > 0 ?
                                <Box sx={{ display: 'flex', cursor: 'pointer' }}
                                    onClick={
                                        () => { ref.current?.scrollIntoView({ behavior: 'smooth' }) }
                                    }>
                                    <Rating
                                        precision={0.1}
                                        value={review_summary.average}
                                        readOnly
                                    />
                                    <Box sx={{ ml: 1.5, mt: .5 }}>
                                        <Typography sx={{ fontSize: '12px', color: '#707070', fontWeight: '600' }}>
                                            ({review_summary.count} reseñas)
                                        </Typography>
                                    </Box>
                                </Box>
                            :
                                <Box sx={{ display: 'flex', gap: '10px' }}>
                                    <div className="ratings-product" style={{ cursor: 'pointer' }}
                                        onClick={
                                            () => { ref.current?.scrollIntoView({ behavior: 'smooth' }) }
                                        }>
                                        <i className="far fa-star"></i>
                                        <i className="far fa-star"></i>
                                        <i className="far fa-star"></i>
                                        <i className="far fa-star"></i>
                                        <i className="far fa-star"></i>
                                    </div>
                                    <Box sx={{ my: 'auto' }}>
                                        <Typography sx={{ fontSize: '12px', color: '#707070', fontWeight: '600', cursor: 'pointer' }}
                                            onClick={() => { ref.current?.scrollIntoView({ behavior: 'smooth' }) }}
                                        >
                                            (0 comentarios)
                                        </Typography>
                                    </Box>
                                </Box>
                        }
                    </Box>
                    {/* Fin Rating del producto */}

                    {/* Precio */}
                    {
                        ['DescuentoProducto', 'DescuentoMarca'].includes(promo) ?
                            <Stack direction="row"
                                justifyContent="flex-start"
                                alignItems="baseline"
                                spacing={2}>
                                <Typography variant="h5" sx={{
                                    color: '#000000', fontWeight: 'normal', mt: 1.5,
                                    textDecoration: 'line-through'
                                }}>
                                    ${price}
                                </Typography>
                                <Typography variant="h5" sx={{ color: '#F90606', fontWeight: 'normal', mt: 1.5 }}>
                                    ${promo_price}
                                </Typography>
                            </Stack>
                            :
                            <Typography variant="h5" sx={{ color: '#F90606', fontWeight: 'normal', mt: 1.5 }}>
                                ${price}
                            </Typography>
                    }
                    {/* Fin Precio */}
                    <PromotionConditions promotion={variant.item_promotion} />

                    {/* Variantes */}
                    <Box sx={{ mt: 1.5, mb: 2.5 }}>
                        {
                            prod_variants.length > 1 &&
                            <>
                                <Typography variant='body1' gutterBottom>Tipos:</Typography>
                                <Box sx={{display: 'flex', justifyContent: 'flex-start', gap: '15px', flexWrap: 'wrap'}}>
                                    {
                                        prod_variants.map((e, i) => {
                                            return (
                                                <Button
                                                    key={e._id}
                                                    variant={
                                                        prod_var_id === e._id ? "contained" : "outlined"
                                                    }
                                                    onClick={ variantSelect(e) }
                                                    sx={{ textTransform: 'lowercase' }}
                                                >
                                                    {
                                                        e.variant_title.trim().length === 0 ?
                                                            `variante No. ${i+1}` : e.variant_title
                                                    }
                                                </Button>
                                            )
                                        })
                                    }
                                </Box>
                            </>
                        }
                    </Box>
                    {/* Fin Variantes */}

                    {/* {
                        item_promotion.promo !== '' &&
                        <Box sx={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', mt: 2, borderRadius: '8px' }}>
                            <Alert
                                severity="info"
                                icon={<InventoryIcon />}
                            >
                                Promociones disponibles
                            </Alert>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={2} sx={{ textAlign: 'center' }}>
                                    <Grid item xl={1} lg={1} md={1} sm={2} xs={2} sx={{ my: 'auto' }}>
                                        <IconButton className='promotions-swiper-button-prev' size='small' disabled={ActivePromotions.length <= 1}>
                                            <ChevronLeftIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xl={10} lg={10} md={10} sm={8} xs={8}>
                                        <Swiper
                                            breakpoints={{
                                                0: {
                                                    slidesPerView: 1,
                                                },
                                                610: {
                                                    slidesPerView: 1,
                                                },
                                                800: {
                                                    slidesPerView: 1,
                                                },
                                                950: {
                                                    slidesPerView: 1,
                                                },
                                                1100: {
                                                    slidesPerView: 1,
                                                },
                                                1200: {
                                                    slidesPerView: 1,
                                                },
                                            }}
                                            spaceBetween={40}
                                            autoHeight={true}
                                            navigation={{
                                                nextEl: '.promotions-swiper-button-next',
                                                prevEl: '.promotions-swiper-button-prev',
                                            }}
                                            loop={true}
                                            pagination={{
                                                clickable: true,
                                                dynamicBullets: true,
                                            }}
                                            modules={[Navigation, Pagination]}
                                        >
                                            {
                                                ActivePromotions.map((res) => (
                                                    <SwiperSlide>
                                                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: '15px', my: 3 }}>
                                                            <Box sx={{ my: 'auto' }}>
                                                                <img className="image_tog_prom" width='120' height="120"
                                                                    style={{ objectFit: 'contain' }} alt={pro_pru}
                                                                    src={pro_pru}
                                                                />
                                                            </Box>

                                                            {
                                                                Object.keys(res.variant_b).length > 0 &&
                                                                <Box sx={{ my: 'auto' }}>
                                                                    <AddIcon fontSize='small' />
                                                                </Box>
                                                            }

                                                            {
                                                                Object.keys(res.variant_b).length > 0 &&
                                                                <Box sx={{ my: 'auto' }}>
                                                                    <img className="image_tog_prom" width='120' height="120"
                                                                        style={{ objectFit: 'contain' }} alt={pro_pru_1}
                                                                        src={pro_pru_1}
                                                                    />
                                                                </Box>
                                                            }

                                                            {
                                                                Object.keys(res.variant_c).length > 0 &&
                                                                <Box sx={{ my: 'auto' }}>
                                                                    <AddIcon fontSize='small' />
                                                                </Box>
                                                            }

                                                            {
                                                                Object.keys(res.variant_c).length > 0 &&
                                                                <Box sx={{ my: 'auto' }}>
                                                                    <img className="image_tog_prom" width='120' height="120"
                                                                        style={{ objectFit: 'contain' }} alt={pro_pru_2}
                                                                        src={pro_pru_2}
                                                                    />
                                                                </Box>
                                                            }
                                                        </Box>
                                                        <Typography variant='body2' paragraph>
                                                            {res.info}
                                                        </Typography>
                                                    </SwiperSlide>
                                                ))
                                            }
                                        </Swiper>
                                    </Grid>
                                    <Grid item xl={1} lg={1} md={1} sm={2} xs={2} sx={{ my: 'auto' }}>
                                        <IconButton className='promotions-swiper-button-next' size='small' disabled={ActivePromotions.length <= 1}>
                                            <ChevronRightIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    } */}

                    {/* Categorias y etiquetas */}
                    <Box sx={{ mt: 3 }}>
                        <Typography variant='body1'>Categorías:
                            {
                                (prod_category && prod_category.length > 0) ?
                                    prod_category.map(({ category }, i) =>
                                        <Link key={i}
                                            style={{ marginLeft: '3px' }}
                                            to={
                                                `/tienda/categoria/${getCategoryURL(category)}`
                                            }>
                                            {
                                                i === prod_category.length - 1
                                                    ? category : `${category}, `
                                            }
                                        </Link>
                                    )
                                    :
                                    (category && category.length > 0) ?
                                        category.map((e, i) =>
                                            <Link key={i}
                                                style={{ marginLeft: '3px' }}
                                                to={
                                                    `/tienda/categoria/${getCategoryURL(e)}`
                                                }>
                                                {
                                                    i === category.length - 1
                                                        ? e : `${e}, `
                                                }
                                            </Link>
                                        )
                                    :
                                        ` N/A`
                            }
                        </Typography>
                    </Box>
                    {/* fin Categorias y etiquetas */}

                    {/* Descripción */}
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} sx={{ mt: 2.5 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant='body1' sx={{ fontWeight: '600' }}>
                                Descripción
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant='body1'>{description}</Typography>
                        </AccordionDetails>
                    </Accordion>
                    {/* Facturación */}
                    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant='body1' sx={{ fontWeight: '600' }}>
                                Facturación
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Puedes solicitar una factura electrónica para todos tus pedidos al momento de realizar tu pedido. Para hacerlo
                                sólo debes llenar todos tus datos en el apartado de facturación del checkout, adjuntando tu Constancia de
                                Situación Fiscal actualizada. De no obtener los datos completos, tu factura no podrá realizarse correctamente.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    {/* información de envíos */}
                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant='body1' sx={{ fontWeight: '600' }}>Información de envíos</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography paragraph>
                                Nuestro servicio de envíos se encuentra disponible únicamente en México.
                            </Typography>
                            <Typography paragraph>
                                El tiempo de entrega podrá ser de <b>1 a 7 días hábiles</b>, contados a partir de que se ha recibido el
                                importe completo de la compra. El tiempo de entrega dependerá del código postal del destino y de la
                                paquetería. En el caso de códigos postales de zonas extendidas, la garantía de entrega no podrá
                                aplicarse.
                            </Typography>
                            <Typography paragraph>
                                Si tu código postal tiene cobertura con entrega a domicilio, el paquete se te
                                entregará hasta la puerta de tu casa. Si, por el contrario, tu domicilio es de
                                zona extendida o de difícil acceso, el paquete llegará a la oficina ocurre más
                                cercana y tendrás cierto tiempo para recoger el pedido.
                            </Typography>
                            <Typography>
                                El costo de envío estándar es de 170 pesos. Para las compras mayores a ${ FREE_SHIPPING_THRESHOLD.toLocaleString('es-MX') } pesos, o en
                                artículos seleccionados, el envío no tendrá costo. La elección de la paquetería será la
                                que consideremos más adecuada y tenga la cobertura hacia su código postal.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                </Grid>
                <Grid item xl={3} lg={12} md={12} sm={12} xs={12}>
                    <Box sx={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;rgba(149, 157, 165, 0.2) 0px 8px 24px;', borderRadius: '8px', p: 3 }}>
                        {
                            (!medicine && !refrigerated) && (
                            stock >= 1
                                ?
                                <Typography variant='body' sx={{ fontSize: '19px', color: '#56C596', fontWeight: 'bold' }}>Disponible para compra</Typography>
                                :
                                <Typography variant='body' sx={{ fontSize: '18px', color: '#e74c3c', fontWeight: 'bold' }}>Producto temporalmente agotado</Typography>
                            )
                        }

                        {/* Cantidad y add-cart */}
                        <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
                            {
                                (!refrigerated && !medicine) &&
                                <>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Cantidad"
                                            variant="outlined"
                                            value={qty}
                                            size="small"
                                            inputProps={{ maxLength: 4 }}
                                            onChange={handleChangeQty}
                                        />
                                    </FormControl>
                                    <Typography variant="body2" display="block" sx={{ mt: .5 }}>
                                        ({stock} disponibles)
                                    </Typography>
                                </>
                            }
                            {
                                // (medicine) ?
                                (medicine || refrigerated) ?
                                    <Box sx={{ my: 3 }}>
                                        <Typography variant="body1" paragraph>
                                            Producto no disponible en tienda en línea, sin embargo, puedes ADQUIRIRLO por medio de WhatsApp.
                                        </Typography>
                                        <Stack direction={matches_1 ? 'column' : 'row'} spacing={2}>
                                            <WhatsAppButton
                                                variant='contained'
                                                startIcon={<WhatsAppIcon />}
                                                fullWidth
                                                LinkComponent='a'
                                                href={
                                                    `https://api.whatsapp.com/send?phone=${SUPPORT_NUMBER}&text=Hola,+quisiera+adquirir+${variant_title ?
                                                        `${title}+${variant_title}`.trim().replace(/\s/g, '+')
                                                        :
                                                        `${title}`.trim().replace(/\s/g, '+')
                                                    }+(${qty > 1 ? `${qty}+piezas` : '1+pieza'
                                                    })`
                                                }
                                                target="_blank" rel="noopener noreferrer"
                                            >
                                                Contactar a un asesor
                                            </WhatsAppButton>
                                            {/* <PhoneButton
                                                variant='contained'
                                                startIcon={<PhoneIcon />}
                                                fullWidth
                                                LinkComponent='a'
                                                href='tel:'
                                            >
                                                Llamar
                                            </PhoneButton> */}
                                        </Stack>
                                    </Box>
                                    // :
                                    // refrigerated
                                    //     ?
                                    //     <>
                                    //         <Typography variant="body1">
                                    //             La disponibilidad de este artículo está limitado a direcciones específicas.
                                    //         </Typography>
                                    //         <Button
                                    //             onClick={() => { setCpModal(true) }}
                                    //             variant='contained'
                                    //             disabled={stock < 1}
                                    //             sx={{ mt: 2, fontWeight: 'bold', width: '100%', height: '50px', textTransform: 'none' }}>
                                    //             Comprobar disponibilidad
                                    //         </Button>
                                    //     </>
                                        :
                                        <Box>
                                            <Button type="submit"
                                                variant='contained'
                                                disabled={stock < 1}
                                                sx={{ mt: 2, fontWeight: 'bold', width: '100%', height: '50px', textTransform: 'none' }}>
                                                Agregar al carrito
                                            </Button>
                                            <Button
                                                onClick={handleBuyNow}
                                                type="submit"
                                                variant='outlined'
                                                disabled={stock < 1}
                                                sx={{ mt: 2, fontWeight: 'bold', width: '100%', height: '50px', textTransform: 'none' }}>
                                                Comprar ahora
                                            </Button>
                                        </Box>
                            }
                        </form>
                        {/*Fin Cantidad y add-cart */}

                        {
                            (!medicine && !refrigerated) &&
                                <PaymentInfo
                                    title={title}
                                    variant_title={variant_title}
                                    freeShipping={freeShipping}
                                />
                        }
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
});

export default ProductContainer;
